export default () => ({
  termsContainer: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    backgroundColor: '#efefef',
    zIndex: 222222,
    justifyContent: 'center',
  },
  innerContainer: {
    backgroundColor: '#ffffff',
    position: 'relative',
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '60%',
    borderRadius: 10,
  },
  consentImg: {
    width: 250,
    objectFit: 'contain',
  },
  messageBox: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    '& p': {
      lineHeight: '40px',
    },
  },
  checkboxLabel: {
    lineHeight: '40px',
  },
  iAcceptBtn: {
    marginTop: 20,
    alignSelf: 'center',
  },
  title: {
    fontWeight: 700,
  },
});
